import { useCallback } from 'react';

import PropTypes from 'prop-types';

import PlaceOrderWidget from '#client/components/PlaceOrderWidget';
import { PAYMENT_ACTIONS, PAYMENT_STATUS } from '#client/pages/CheckoutSmartLlc/constants/payment';
import { usePaymentContext } from '#client/pages/CheckoutSmartLlc/hooks/usePaymentContext';
import useTrackPaymentError from '#client/pages/CheckoutSmartLlc/hooks/useTrackPaymentError';

import TermsAndConditions from '../TermsAndConditions';

function PaymentDetails({ billingInfo, onPlaceOrder }) {
  const [paymentState, dispatch] = usePaymentContext();
  const { errorMessage, hasFatalError } = useTrackPaymentError({
    error: paymentState.error
  });

  const isLoading = paymentState.status === PAYMENT_STATUS.PENDING;

  const handlePaymentError = useCallback(
    (paymentError) => {
      dispatch({
        type: PAYMENT_ACTIONS.PLACE_ORDER_ERROR,
        payload: {
          isFatal: false,
          message: paymentError.message,
          errorCode: paymentError.errorCode
        }
      });
    },
    [dispatch]
  );

  const handlePaymentMethodChange = useCallback(
    (newPaymentMethod) => {
      dispatch({
        type: PAYMENT_ACTIONS.SET_PAYMENT_INSTRUMENT,
        payload: {
          cardToken: newPaymentMethod.cardToken,
          paymentMethodId: newPaymentMethod.paymentMethodId,
          paymentMethodType: newPaymentMethod.paymentMethodType
        }
      });
    },
    [dispatch]
  );

  return (
    <>
      <PlaceOrderWidget
        billingInfo={billingInfo}
        cardToken={paymentState.cardToken}
        errorMessage={errorMessage}
        hasFatalError={hasFatalError}
        isLoading={isLoading}
        paymentMethodId={paymentState.paymentMethodId}
        onChange={handlePaymentMethodChange}
        onError={handlePaymentError}
        onPlaceOrder={onPlaceOrder}
      />
      <TermsAndConditions />
    </>
  );
}

PaymentDetails.propTypes = {
  billingInfo: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }),
  onPlaceOrder: PropTypes.func.isRequired
};

export default PaymentDetails;
